import { render, staticRenderFns } from "./TrainingCitiesForm.vue?vue&type=template&id=67fac86d&"
import script from "./TrainingCitiesForm.vue?vue&type=script&lang=js&"
export * from "./TrainingCitiesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports